import _typeof from "@babel/runtime/helpers/typeof";
import { isNullOrUndefined } from "./fn";
export var assertBooleanOrNull = function assertBooleanOrNull(value) {
  var funcName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'function';
  var argName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'argument';
  return console.assert(
  // eslint-disable-line no-console
  typeof value === 'boolean' || isNullOrUndefined(value), "Expecting ".concat(argName, " to be boolean or null in call to ").concat(funcName, ", '").concat(_typeof(value), "' found"));
};